var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"milestone-sidebar-content"},[_c('div',{staticClass:"milestones-sidebar-list",style:(`${_vm.show_details?'width: 50px;':''}`)},[_vm._t("list",null,{"milestones":_vm.milestones})],2),(_vm.show_details)?_c('div',{staticClass:"milestones-sidebar-details"},[_vm._t("details")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }